export default __webpack_public_path__ + "static/media/Photographer.f287756d.JPG";